import React from 'react';
import { Card, Button, Typography } from 'antd';
import { useDispatch } from 'react-redux';
import { setLanguage } from '../../store/slices/uiSlice';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS } from '../../utils/constants';

const { Title, Text } = Typography;

export default function LanguageSelect() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const handleSelect = (code) => {
    dispatch(setLanguage(code));
    i18n.changeLanguage(code);
    navigate('/login');
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1a6b2a 0%, #52c41a 100%)' }}>
      <Card style={{ width: 400, borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.15)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <img src="/logo192.png" alt="logo" style={{ width: 64, height: 64, borderRadius: 12, marginBottom: 8 }} onError={(e) => { e.target.style.display = 'none'; }} />
          <Title level={3} style={{ color: '#1a6b2a', margin: 0 }}>Kheti Hisaab</Title>
          <Text type="secondary">Select your language / अपनी भाषा चुनें</Text>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          {SUPPORTED_LANGS.map((lang) => (
            <Button key={lang.code} size="large" onClick={() => handleSelect(lang.code)}
              style={{ height: 48, fontSize: 15, borderRadius: 8, border: '1.5px solid #1a6b2a', color: '#1a6b2a' }}>
              {lang.label}
            </Button>
          ))}
        </div>
      </Card>
    </div>
  );
}
